module.exports = __webpack_public_path__ + "d9a9e22a62152e996ae09d02e8a12d0e.fbx";